
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { AssetManagementRequest } from '../entities/asset-management/asset-management-request';
import { ManualOnboardingResponse } from '../entities/asset-management/assset-management-response';
import { axiosInstance } from "../axios-instance";
import { BaseSubscriptionPlanResponse, BaseSubsctiptionPlanParameters } from './types';

class ManualOnboardingService {
    private authClient: OAuth2Client | null;

    private baseUrl: string;

    constructor(authClient: OAuth2Client | null, baseUrl: string) {
        this.authClient = authClient;
        this.baseUrl = baseUrl;
    }

    assetManualOnboarding(input: AssetManagementRequest): Promise<AxiosResponse<ManualOnboardingResponse>> {
        const accessToken = localStorage.getItem('accessToken');
        return axiosInstance.post<ManualOnboardingResponse>(`${this.baseUrl}/supplierDevices`, input, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }

  getBaseSubsctiptionPlans(input: BaseSubsctiptionPlanParameters): Promise<AxiosResponse<BaseSubscriptionPlanResponse>> {
    const accessToken = localStorage.getItem('accessToken'); 
    return axiosInstance.get<BaseSubscriptionPlanResponse>(`${this.baseUrl}/catalogs/plans`, {
      params: input,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }
}

export default ManualOnboardingService;